export default __webpack_public_path__ + "static/media/icon_camera.aa61cfb6.svg";